import { render, staticRenderFns } from "./CardTarjaPanelaSportv.vue?vue&type=template&id=9c0d4b52&scoped=true"
import script from "./CardTarjaPanelaSportv.vue?vue&type=script&lang=js"
export * from "./CardTarjaPanelaSportv.vue?vue&type=script&lang=js"
import style0 from "./CardTarjaPanelaSportv.vue?vue&type=style&index=0&id=9c0d4b52&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c0d4b52",
  null
  
)

export default component.exports